import BaseModel from '../../base';
import OptionPair from './pair/index';

export default class Option extends BaseModel {
  constructor(option = {}, url) {
    super(option, url);

    this.name = option.name;
    this.score = option.score;
    this.penalty_score = option.penalty_score;
    this.images = [].concat(option.image || option.images || []);
    this.is_correct = option.is_correct || false;
    this.parent_id = option.parent_id || null;
    this.pair = option.pair ? new OptionPair(option.pair, 'pair') : null;
  }

  get hasNotUploadImages() {
    return this.images.every((i) => !i.id);
  }

  get image() {
    const [image] = this.images;
    return image;
  }

  get hasParent() {
    return !!this.parent_id;
  }

  get putFormat() {
    const {
      id,
      name,
      score,
      pair,
      images,
      isServer,
      parent_id,
      is_correct,
      penalty_score,
      hasNotUploadImages,
    } = this;

    return {
      ...isServer ? { id } : [],
      parent_id,
      is_correct,
      penalty_score,
      score: score || 0,
      name: name || null,
      ...hasNotUploadImages ? { images } : [],
      ...pair ? { pair: pair.putFormat } : [],
      delete_images: !!name,
    };
  }

  setPair(val) {
    this.pair = val ? new OptionPair(val, 'pair') : null;
  }
}
